import { render, staticRenderFns } from "./ModPviForm.vue?vue&type=template&id=4ae5ce22&"
import script from "./ModPviForm.vue?vue&type=script&lang=js&"
export * from "./ModPviForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports